import React from 'react';
import {useContextSelector} from 'use-context-selector';
import {useLocation} from 'react-router-dom';
import {Helmet} from 'react-helmet';

import {Container, Row, Col, Alert, Button, Card} from 'react-bootstrap';

import {LocalContext} from '../context/LocalContext';

import {useTranslation} from 'react-i18next';
import {LinkContainer} from 'react-router-bootstrap';
import Layout from '../common/Layout';

const NotFound = (props) => {
    const {t} = useTranslation();

    const location = useLocation();
    const clientOnline = useContextSelector(LocalContext, v => v[0].clientOnline);

    return <Layout navSecondaryShow={props.navSecondaryShow} className={'bg-light'} contentBackgroundArt={true}>
        <Helmet><title>{t('NotFound.page-head-title')}</title></Helmet>
        <Container className="mt-5 mb-5" fl={"md"}>
            < Row >
                <Col
                    xl={props.layoutNarrow ? {span: 10, offset: 1} : {span: 8, offset: 2}}
                    lg={props.layoutNarrow ? {span: 12, offset: 0} : {span: 10, offset: 1}}
                    md={{span: 12, offset: 0}}
                ><h1>{t('NotFound.not-found')}</h1></Col>
            </Row >
            <Row className="mt-4">
                <Col
                    xl={props.layoutNarrow ? {span: 10, offset: 1} : {span: 8, offset: 2}} 
                    lg={props.layoutNarrow ? {span: 12, offset: 0} : {span: 10, offset: 1}}
                    md={{span: 12, offset: 0}}
                >
                    <Card>
                        <Card.Body>
                            <Alert variant="danger" className="mb-0">
                                {location.pathname !== "/request-status/not-found" ?
                                    <p className="text-center">{t('NotFound.not-found-message.p1')}<br /><em>{location.pathname}</em></p> : null}
                                <p className="text-center mb-0">{t('NotFound.not-found-message.p2')}</p>
                            </Alert>
                        </Card.Body>
                        {
                            !props.hideControls ?
                                <Card.Footer>
                                    <LinkContainer disabled={!clientOnline} to={'/'} exact={true}>
                                        <Button className="float-right">{t('NotFound.go-to-home')}</Button>
                                    </LinkContainer>
                                </Card.Footer> :
                                null
                        }
                    </Card>
                </Col>
            </Row>
        </Container>
    </Layout>

}

export default NotFound;
